"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeProductFromCartCompleted = exports.removeProductFromCartCanceled = exports.removeProductFromCartStart = void 0;
const constants_1 = require("../constants");
const getRemovedProductProps = ({ product, session, }) => ({
    [constants_1.EventProperty.PRODUCT_ID]: product.id,
    [constants_1.EventProperty.PRODUCT_CATEGORY]: product.category,
    [constants_1.EventProperty.PRODUCT_NAME]: product.name,
    [constants_1.EventProperty.PRODUCT_PRICE]: product.price,
    [constants_1.EventProperty.PRODUCT_SKU]: product.sku,
    [constants_1.EventProperty.PRODUCT_TOTAL_PRICE]: product.totalPrice,
    [constants_1.EventProperty.USER_ID]: session.userID,
    [constants_1.EventProperty.CUSTOMER_NAME]: session.customer,
    [constants_1.EventProperty.SESSION_ID]: session.sessionID
});
exports.removeProductFromCartStart = ({ product, session, }) => {
    const props = getRemovedProductProps({
        product,
        session,
    });
    window.analytics.track(constants_1.EventName.PRODUCT_ELIMINATED_FROM_CART_START, props);
};
exports.removeProductFromCartCanceled = ({ product, session, }) => {
    const props = getRemovedProductProps({
        product,
        session,
    });
    window.analytics.track(constants_1.EventName.PRODUCT_ELIMINATED_FROM_CART_CANCELED, props);
};
exports.removeProductFromCartCompleted = ({ product, session, }) => {
    const props = getRemovedProductProps({
        product,
        session,
    });
    window.analytics.track(constants_1.EventName.PRODUCT_ELIMINATED_FROM_CART_COMPLETED, props);
};
